import {Base64} from 'js-base64'

export const TOKEN_STG_KEY = 'apmToken'

export function rememberToken (token) {
  localStorage.setItem(TOKEN_STG_KEY, token)
}

export function getToken () {
  // let token = null
  // token = sessionStorage.getItem(TOKEN_STG_KEY)
  // if (token == null) {
  //   token = localStorage.getItem(TOKEN_STG_KEY)
  //   if (token) {
  //     sessionStorage.setItem(TOKEN_STG_KEY, token)
  //   }
  // }
  // return token
  // let cookie = document.cookie
  // let token = cookie.split('=')[1]
  // return token
  return ''
}

export function setToken (token) {
  sessionStorage.setItem(TOKEN_STG_KEY, token)
}

export function setCookie (name, value, seconds) {
  seconds = seconds || 0
  var expires = ''
  if (seconds !== 0) {
    var date = new Date()
    date.setTime(date.getTime() + (seconds * 1000))
    expires = '"; expires=' + date.toGMTString()
  }
  document.cookie = name + '="' + value + expires + '; path=/'
}

export function clearToken () {
  setCookie('refreshToken', '', -1)
}

export function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) !== -1) return decodeURI(c.substring(name.length, c.length))
  }
  return ''
}

// 删除Cookie
export function delCookie (name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  document.cookie = name + '=' + cval + ';  expires=' + exp.toGMTString()
}

export function getAuthenFromToken () {
  let tokenStr = getToken()
  return `Bearer ${tokenStr}`
}

export function getExpiresFromToken () {
  let exp = null
  let tokenStr = document.cookie
  if (tokenStr != null) {
    let ExpiresSubStr = tokenStr.split(',')[2]
    exp = ExpiresSubStr.split(':')[1]
  }
  return parseInt(exp)
}

export function getRefreshTokenFromToken () {
  let refreshToken = null
  let tokenStr = document.cookie
  if (tokenStr != null) {
    let RefreshTokenSubStr = tokenStr.split(',')[3]
    refreshToken = RefreshTokenSubStr.split(':')[1]
  }
  return refreshToken
}

export function getUserInfoFromToken () {
  const ADMIN_ROLE = 'admin'
  const GUEST_ROLE = 'normal'
  let user = null
  let token = getToken()
  if (token != null) {
    let payloadBStr = token.split('.')[1]
    if (payloadBStr != null) {
      let payloadStr = Base64.decode(payloadBStr)
      let payload = JSON.parse(payloadStr)
      user = {
        id: payload.id,
        name: payload.user,
        role: payload.role === 1 ? ADMIN_ROLE : GUEST_ROLE,
        loginTs: payload.iat
      }
    }
  }
  return user
}

export function getUserRoleFromToken (token) {
  console.log('getUserRoleFromToken')
  const AdmimRole = 'admin'
  const NormalRole = 'normal'
  let role = null
  if (token != null) {
    let payloadBStr = token.split('.')[1]
    console.log(payloadBStr)
    if (payloadBStr != null) {
      let payloadStr = Base64.decode(payloadBStr)
      let payload = JSON.parse(payloadStr)
      let roleStr = payload.scopes
      console.log(roleStr)
      if (AdmimRole === roleStr[0].split('.')[1]) {
        role = AdmimRole
      } else {
        role = NormalRole
      }
    }
  }
  return role
}



// WEBPACK FOOTER //
// ./src/js/tokenProcess.js